<template>
  <div class="row p-0 fs-14" id="TemplatePrescription">
    <div class="col-12 row mb-3">
      <div class="col-3 d-flex">
        <div v-if="clinic">
          <p class="mb-0 fs-12 font-bold uppercase">
            {{
              clinic && clinic.organization
                ? clinic.organization.authority_in_charge
                : ""
            }}
          </p>
          <p class="mb-0 fs-12 uppercase">
            {{
              clinic && clinic.organization
                ? clinic.organization.name
                : ""
            }}
          </p>
          <p class="mb-0 fs-13">
            {{ clinic.name }}
          </p>
          <p class="mb-0 fs-13" v-if="clinic.address">
            Địa chỉ: {{ clinic.address }}
          </p>
          <p class="mb-0 fs-13" v-if="clinic.phone">
            Số điện thoại: {{ clinic.phone }}
          </p>
        </div>
      </div>
      <div class="col-6">
        <p class="mb-0 text-center text-uppercase font-weight-bold">
          CỘNG HOÀ XÃ HỘI CHỦ NGHĨA VIỆT NAM
        </p>
        <p class="mb-0 text-center font-weight-bold">
          Độc lập - Tự do - Hạnh phúc
        </p>
        <p class="mb-3 text-center font-weight-bold">
          ------------------------------------
        </p>
      </div>
    </div>
    <div class="col-12">
      <p class="mb-3 text-center text-uppercase font-weight-bold fs-20">
        ĐƠN THUỐC / PRESCRIPTION
      </p>
    </div>
    <div>
      <div v-if="disease">
        <div>
          <span class="fw-700">Họ tên bệnh nhân</span>
          <span class="italic">/Patient name: </span>
          <span class="fw-700">{{
            disease.person && disease.person.name
          }}</span>
        </div>
        <div class="flex">
          <div class="w-1/3">
            <span class="fw-700">Ngày sinh</span>
            <span class="italic">/ DOB: </span>
            <span>{{ getDate() }}</span>
          </div>
          <div class="ml-2">
            <span class="fw-700">Giới tính</span>
            <span class="italic">/ Gender: </span>
            <span>{{ getGender() }}</span>
          </div>
        </div>
        <div>
          <span class="fw-700">Địa chỉ</span>
          <span class="italic">/Address: </span>
          <span>{{ disease.person && disease.person.address }}</span>
        </div>
        <div>
          <span class="fw-700">Chẩn đoán</span>
          <span class="italic">/ Diagnostic: </span>
          <span>{{ disease.diseases_name }}</span>
        </div>
        <div class="mt-2" v-if="prescription">
          <div>
            <span class="fw-700">Chỉ định thuốc </span>
            <span class="italic">/ Medication</span>
          </div>
          <div
            class="row"
            v-for="(medicine, index) in prescription.person_medicines"
            :key="index + 'medicine'"
          >
            <div class="col-8">
              <div>
                {{ `${index + 1}. ${medicine.name}` }}
              </div>
              <div class="ml-3.5 italic" v-if="medicine.doctor_note">
                Cách dùng: {{ medicine.doctor_note }}
              </div>
              <div class="ml-3.5 italic" v-if="medicine.side_effect">
                Ghi chú: {{ medicine.side_effect }}
              </div>
            </div>
            <div class="col-4">
              <div>
                Số lượng: {{ medicine.amount }} {{ medicine.amount_unit }}
              </div>
            </div>
          </div>
        </div>

        <div>
          <span class="fw-700">Lời dặn của bác sĩ </span>
          <span class="italic">/ Advice of doctor</span>
          <div v-if="prescription.description">
            - {{ prescription.description }}
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-6 text-center">
            <!-- <div class="flex justify-center">
              <div>Ngày <span>....... </span></div>
              <div>tháng <span>....... </span></div>
              <div>năm <span>....... </span></div>
            </div> -->
            <div class="fw-700">Bác sĩ ký và ghi tên</div>
            <div class="italic">Doctor (Fullname and Signature)</div>
          </div>
          <div class="col-6 text-center">
            <div class="fw-700">Người duyệt đơn</div>
            <div class="italic">Reviewed by</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import appUtils from '../../../utils/appUtils'
export default {
  name: 'TemplatePrescription',
  props: ['disease', 'prescription'],
  data () {
    return {
      clinic: null,
      loading: false
    }
  },
  mounted () {
    this.clinic = this.$globalClinic
  },
  methods: {
    getGender () {
      return this.disease?.person?.gender && appUtils.getGender(this.disease.person.gender)
    },
    getDate () {
      return this.disease?.person?.birthday && window.moment(this.disease.person.birthday).format('DD/MM/YYYY')
    }
  }
}
</script>
